/* import __COLOCATED_TEMPLATE__ from './overflow-menu.hbs'; */
import templateOnlyComponent from '@ember/component/template-only';
export default templateOnlyComponent();